import React from 'react'
import { Button, Form,  Image,  Input, Progress, Select,  } from 'semantic-ui-react'
import './AddSeries.scss'
import {map} from 'lodash'
import noImage from '../../../../img/noimage.png'

import db, { storage } from '../../../../utils/firebase'
import { toast } from 'react-toastify'
import { useDropzone } from 'react-dropzone'
import {v4 as uuidv4} from 'uuid'
import ListaDeTiposDePeliculas from '../../../listaDeTiposDePeliculas/ListaDeTiposDePeliculas'
import { agregarCaracter } from '../../../../utils/Validations'


export default function AddSeries(props) {

    const {user, setShowModal, setTitleModal, setContentModal}=props

    

    const agregarSerie = () =>{

        setShowModal(true)
        setTitleModal("Agregar Serie")
        setContentModal( <DisplaySerie  /> )

    }

    return (
        <div className="profile-admin-serie" >
            <h2>Series</h2>
            <Button onClick={agregarSerie} >Agregar Serie</Button>
        </div>
    )
}


function DisplaySerie (){

    const [isLoading, setIsLoading] = React.useState(false)
    const [porcentaje, setPorcentaje] = React.useState(null)
    const [file, setFile] = React.useState(null)
    const [fileBanner, setFileBanner] = React.useState(null)
    const [tipoDeSerie,setTipoDeSerie] = React.useState("")
    const [reloadDataSeries,setReloadDataSeries] = React.useState(false)
    const [numEpisodio,setNumEpisodio] = React.useState(1)

    const [listData, setListData] = React.useState({
        title: "",
        description:"",
        temporada:"",
        episodio:"",
        video:"",
        urlPoster:""
    })
    const [listaSeries,setListaSeries] = React.useState()
    const [listaSerieSeleccionada,setListaSerieSeleccionada] = React.useState()


    const lista = [
        {
            title:"terror",id:0
        },
        {
            title:"accion",id:1
        },
        {
            title:"romance",id:2
        },
        {
            title:"coreanas",id:3
        },
        {
            title:"comedia",id:4
        },
        {
            title:"adolescentes",id:5
        },
        {
            title:"drama",id:6
        },
        {
            title:"animado e infantil",id:7
        },
        {
            title:"ciencia ficcion",id:8
        },
        {
            title:"documental",id:9
        },
        {
            title:"novelas",id:10
        },
        
    ]

    React.useEffect(()=>{
        setListData({...listData,episodio:`episodio${numEpisodio}`})

    },[numEpisodio])




    React.useEffect(()=>{

        db.collection("series").orderBy("createAt","desc").limit(5).get().then((response)=>{

            if(response.docs.length>0){
                const result = response.docs.map((doc)=>{
                    const data = doc.data()
                    data.id=doc.id
                    return{
                        title:data?.title,
                        id:data?.uuidPoster,
                        idSerie:data?.id,
                        temporadas:data?.temporadas
                        
                    }
                })
                setListaSeries(result)
            }

        })

    },[reloadDataSeries])


    
    
    const onChange= (e) =>{

        setListData({
            ...listData,
            [e.target.name]: e.target.value
        })
    }

    const onDrop = React.useCallback((acceptedFiles) =>{

        const file= acceptedFiles[0]
        setFile(file)
        setFileBanner(URL.createObjectURL(file))
        

    },[])

    const {getInputProps,getRootProps}=useDropzone({
        accept:"image/*",
        noKeyboard:true,
        onDrop

    })

    const uploadImage = (filePoster) =>{

        const ref = storage.ref().child(`series/${filePoster}`)
        return ref.put(file)

    }
    

    const onSubmit = () =>{
        setNumEpisodio(numEpisodio+1)
        let cadenaOriginal = listData.video;
        let caracterAgregado = "/e";
        let posicion = 21; 
        const cpFormateado = cadenaOriginal.substring(0, posicion) + caracterAgregado + cadenaOriginal.substring(posicion);


        
        
        if(listaSeries?.length>0){
            if(listaSerieSeleccionada){
                const serie=listaSeries.filter((doc)=>doc.title=== listaSerieSeleccionada)
                db.collection("series").doc(serie[0].idSerie).collection(listData?.temporada).where("video","==",cpFormateado).get().then((response)=>{
                    
                    if(response.docs.length>0){
                        toast.error("este episodio ya eciste")
                      

                    }else{
                        db.collection("series").doc(serie[0].idSerie).collection(listData.temporada).add({
                            episodio:listData.episodio,
                            video:listData.video.trim(),
                            createAt:new Date(),
                            temporada:listData.temporada,
                            title:serie[0].title.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,""),
                            uuidPoster:serie[0].id,
                        }).then(()=>{
                            toast.success("subido")

                        })

                    }
                }).finally(()=>{
                    const result = serie[0]?.temporadas?.includes(listData?.temporada)
                            if(!result){
                                db.collection("series").doc(serie[0]?.idSerie).update({
                                    temporadas:[
                                        ...serie[0]?.temporadas,
                                        listData?.temporada,
                                        
                                    ]
                                }).then(()=>{
                                    setReloadDataSeries(!reloadDataSeries)
                                })
                            }

                    
                })
            }else{


            const filePoster= uuidv4()

            if(listData.urlPoster.length>2){

                db.collection("series").add({
                    uuidPoster:filePoster,
                    createAt:new Date(),
                    description:listData.description,
                    title:listData.title.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,""),
                    type:tipoDeSerie,
                    temporadas:[],
                    urlPoster:listData?.urlPoster
                    
                }).then(()=>{
                    toast.success("Subido")
                    
                })

            }else{

                uploadImage(filePoster).on("state_changed", (snapshot) =>{
                    const progressPorcentaje = Math.round(
                        (snapshot.bytesTransferred/snapshot.totalBytes)*100
                    )
                    setPorcentaje(progressPorcentaje)
                },
                (err)=>{
    
                },
                ()=>{
                    storage.ref(`series/${filePoster}`).getDownloadURL().then((url)=>{
    
                        db.collection("series").add({
                            uuidPoster:filePoster,
                            createAt:new Date(),
                            description:listData.description,
                            title:listData.title.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,""),
                            type:tipoDeSerie,
                            temporadas:[],
                            urlPoster:url
                            
                        })
                    })
    
                  })
                    
    
                }
            }

        }else{
            const filePoster= uuidv4()
            uploadImage(filePoster).on("state_changed", (snapshot) =>{
                const progressPorcentaje = Math.round(
                    (snapshot.bytesTransferred/snapshot.totalBytes)*100
                )
                setPorcentaje(progressPorcentaje)
            },
            (err)=>{

            },
            ()=>{
                storage.ref(`series/${filePoster}`).getDownloadURL().then((url)=>{

                    db.collection("series").add({
                        uuidPoster:filePoster,
                        createAt:new Date(),
                        description:listData.description,
                        title:listData.title.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,""),
                        type:tipoDeSerie,
                        temporadas:[],
                        urlPoster:url
                        
                    })
                })

              })
            }
        


    
        }

    const updateInfo = () =>{
        
      /*  db.collection(`${listData.album}`).doc(`${listData.title}`).collection(`${listData.capitulo}`).add({
            episodio:listData.episodio,
            urlEpisodio:listData.urlEpisodio,
            doc:listData.title,
            capitulo: listData.capitulo,
            type: listData.type

            
            
        }).then(() =>{
            toast.success("se agrego")
            
        }).catch((err) =>{
        }).finally(() =>{
            setIsLoading(false)
        })
        */
    }
    
    return(
        <div>


                    <Form className="add-serie-form"  as={Form}  onSubmit={onSubmit} onChange={onChange}  >

                                        <Form.Field className="serie-banner" >
                                            <div
                                                {...getRootProps()}
                                                className="banner"
                                                style={{backgroundImage: `url('${fileBanner}')`}}
                                                />
                                            <input {...getInputProps()} />
                                            {!fileBanner && <Image src={noImage}  />}
                                        </Form.Field>
                                        <Form.Field className="serie-avatar" >
                                            <div
                                                className="avatar"
                                                style={{backgroundImage: `url('${fileBanner ? fileBanner : noImage}')`}}
                                            />
                                        </Form.Field>

                                        <Form.Field   >
                                                {
                                                    !listaSerieSeleccionada &&(

                                                        <ListaDeTiposDePeliculas
                                                            arrayLista={lista}
                                                            nameColeccion="typo de serie"
                                                            obtenerListaSeleccionada={setTipoDeSerie}
                                                        />
                                                    )
                                                }
                                                {
                                                    listaSeries &&(
                                                        <ListaDeTiposDePeliculas
                                                            arrayLista={listaSeries}
                                                            nameColeccion="lista de series"
                                                            obtenerListaSeleccionada={setListaSerieSeleccionada}

                                                        />

                                                    )
                                                }


                                                {
                                                    !listaSeries &&(
                                                        <>
                                                       

                                                            <Input
                                                                placeholder="ingrese nombre de la serie"
                                                                name="title"
                                                            />
                                                           
                                                        </>
                                                    )
                                                }
                                                {
                                                    listaSerieSeleccionada ? (
                                                        <>

                                                        <Form.Input
                                                            placeholder="temporada"
                                                            name="temporada"
                                                          
                                                            

                                                            
                                                            
                                                        />
                                                        <div className='containerEpisodio' >

                                                            <Button
                                                                content={`${listData.episodio}`}
                                                                className='buttomEpisodioActual'
                                                                disabled
                                                            />
                                                            <Input
                                                                placeholder={`${numEpisodio}`}
                                                                onChange={(e)=>setNumEpisodio(parseInt(e?.target?.value))}

                                                            />
                                                        </div>
                                                        <Input
                                                            placeholder="video"
                                                            name="video"

                                                        />
                                                       
                                                    </>

                                                    ):(
                                                        <>
                                                        <Input
                                                                placeholder="URL DE IMAGEN SERIE"
                                                                name="urlPoster"
                                                            />
                                                            <Input
                                                                placeholder="ingrese nombre de la serie"
                                                                name="title"
                                                            />
                                                        <Input
                                                            placeholder="description"
                                                            name="description"
                                                        />
                                                        
                                                       

                                                        </>
                                                    )
                                                }

                                               
                                                
                                              
                                                
                                                
                                        </Form.Field>
                            
                                <Button loading={isLoading} type="submit" >Update Poster</Button>
                                <Progress percent={porcentaje} />
                        </Form>

                            <Button loading={isLoading} onClick={updateInfo} >Update Informacion</Button>
        </div>

                        
           )
        }
    
        